import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { AppState } from './model';
import { APP_LOADERS } from './utils';

export const selectAppState = (state: RootState) => state.app;

export const selectCurrentUser = createSelector(
  selectAppState,
  ({ user }: AppState) => user,
);
export const selectCurrentUserId = createSelector(
  selectAppState,
  ({ user }: AppState) => user?.userId,
);

export const selectCredentials = createSelector(
  selectAppState,
  ({ loginData = {} }: AppState) => loginData,
);

export const selectSearchData = createSelector(
  selectAppState,
  ({ searchForm = {} }: AppState) => searchForm,
);

export const makeSelectAppLoader = (loader: APP_LOADERS) =>
  createSelector(
    selectAppState,
    ({ appLoaders }: AppState) => !!appLoaders?.[loader],
  );

export const selectAppSettings = createSelector(
  selectAppState,
  ({ settings }: AppState) => settings,
);

export const selectAppMode = createSelector(
  selectAppState,
  ({ settings }: AppState) => settings.mode,
);

export const selectIsCleanerMode = createSelector(
  selectAppMode,
  (mode) => mode === 'cleaner',
);
